/**
 * Created by antonio on 26/09/14.
 */
define('payment/templates/deposit-renderer',['jquery', 'boxes/helpers/payment-renderer-helper', 'boxes/helpers/formValidation', 'boxes/helpers/message-popup', 'boxes/helpers/box-loading',
	'payment/handlers/formTemplateHandlers/formTemplateHandlers', 'payment/handlers/paymentMethodHandlers/paymentMethodHandlers',
	'boxes/events/feeEvent', 'all/jquery/jquery.mustache'], function ($, paymentRendererHelper, formValidation, messagePopup, boxLoading, formTemplateHandlers, paymentMethodHandlers, feeEvent) {
    'use strict';

    function setupSelectBoxCurrencies(depositBox, methodForm) {
        var $currencies = methodForm.find('.currencies').find('select');
        $currencies.off('change').on('change', function () {
            depositBox.model.paymentController.selectedCurrency = this.value;
            clearPreviousSelections(depositBox);

            var controller = depositBox.model.paymentController;
            var selectedFormTemplate = controller.getSelectedFormTemplate();
            feeEvent.resetFee(depositBox, selectedFormTemplate.paymentMethod.methodId);
        });
    }

    function clearPreviousSelections(depositBox) {
        //clear selected amount
        var $amountButtons = depositBox.$box.find('.btn');
        var $activeButton = $amountButtons.filter('.active');
        $activeButton.removeClass('active');
        //clear filled amount
        depositBox.$box.find('.amount-box').find('input').val('');
    }

    function emptyInputFields(depositBox) {
        depositBox.$box.find('.form-control.empty').val('');
    }

    function render(formTemplate, depositBox) {
        var paymentMethod = formTemplate.paymentMethod;
        var $paymentMethodForm = depositBox.$box.find(formTemplate.getSelectorClass());

        paymentRendererHelper.reInitializeAmountAndFeeBoxes(depositBox);

        paymentRendererHelper.setupMustacheTemplate($paymentMethodForm, formTemplate.getMustacheClass(), formTemplate.formTemplateData);

        formTemplateHandlers.setupFormTemplate($paymentMethodForm, paymentMethod.formTemplateCode, formTemplate.formTemplateData, depositBox);
        paymentMethodHandlers.setupDepositFormTemplate(paymentMethod.methodName, depositBox);
        setupSelectBoxCurrencies(depositBox, $paymentMethodForm);

		paymentRendererHelper.addValidations(formTemplate, depositBox);
        clearPreviousSelections(depositBox);
        emptyInputFields(depositBox);


		//Fix in order to reset the form, as it seems that it got broken again..
		var controller = depositBox.model.paymentController;
		var selectedFormTemplate = controller.getSelectedFormTemplate();
		feeEvent.resetFee(depositBox, selectedFormTemplate.paymentMethod.methodId);

        paymentRendererHelper.setupAccountSelectionHandler(depositBox.$box, paymentMethod.formTemplateCode, formTemplate);
		paymentRendererHelper.setupDeselectAccountWhenAddingExternalId($paymentMethodForm);
        paymentRendererHelper.triggerAccountSelectionEvent(depositBox.$box, paymentMethod.formTemplateCode);


		$paymentMethodForm.show();
    }

    var depositRenderer = {};
    depositRenderer.render = render;
    return depositRenderer;
});

